"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = flexLeft;
function flexLeft() {
  return /*css*/"\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n  ";
}